<template>
  <div class="back-button" :class="dark ? 'dark' : ''" @click="back">
    <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M4.53858 9.31409H20.0295C21.7692 9.31409 21.7692 6.60163 20.0295 6.60163H4.53858L8.76338 2.36341C10.006 1.09194 8.10067 -0.857645 6.85808 0.413822L0.479453 6.94069C-0.100422 7.44927 -0.183261 8.38168 0.396614 8.97503L6.85808 15.5867C8.10067 16.8581 9.92313 14.9086 8.68054 13.6371L4.53858 9.31409Z"/>
    </svg>
    <span>
      {{ text || $t('misc.backButtonText') }}
    </span>
  </div>
</template>
<script>
export default {
  name: 'back-btn',
  props: {
    dark: Boolean,
    text: String,
    shouldPop: Boolean,
    canReturn: Boolean,
    backRoute: Object
  },
  methods: {
    back() {
      if (this.shouldPop && this.canReturn) {
        this.$router.back()
      } else if (this.backRoute) {
        this.$router.replace(this.backRoute)
      }

      this.$emit('click')
    }
  }
}
</script>
<style lang="scss">
.back-button {
  display: inline-flex;
  align-items: center;
  padding: 2rem 1rem 1rem;
  color: white;
  cursor: pointer;

  &.dark {
    color: #A217AB;
    font: {
      weight: 900;
      size: 1.5rem
    }

    & > svg  > path {
      fill: #A217AB;
    }
  }

  svg {
    vertical-align: middle;
    margin-right: 8px;

    & > path {
      fill: #FFF;
    }
  }
}
</style>
